import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import LoadingCentered from "../../common/loaders/loadingcentered";
import { generatePdfReport } from "../../api";
import { authSelector } from "../../reducers";
import { blobToDataURL, logoFetch, logoUrl } from "../../common/utils";

export function PdfModal({ employmentCertificate, setPdf }) {
  const { t, i18n } = useTranslation();
  const [objectURL, setObjectURL] = useState("");
  const [showLoading, setShowLoading] = useState(false);

  const { companyLogoUrl, company } = useSelector(authSelector);
  const organizationLogoUrl = company?.logoUrl;

  const hide = () => setPdf(null);

  useEffect(() => {
    async function fetchReport() {
      setObjectURL("");
      setShowLoading(true);
      if (employmentCertificate !== null) {
        //const json = (await contractGet(contract.contractId)).data;
        const json = { ...employmentCertificate };

        let logo = "";
        if (json.companyLogoUrl?.length) {
          if (json.companyLogoUrl.startsWith("images/")) {
            logo = logoUrl(json.companyLogoUrl); // orgization logo from eSalary
          } else {
            logo = logoUrl("", json.companyLogoUrl); // organization logo from S3
          }
        } else {
          logo = logoUrl(companyLogoUrl, organizationLogoUrl); // company logo from organization / auth token if the corresponding fields in json.company are empty
        }

        json.companyLogo = await logoFetch(logo);

        const lang = json.language ?? "fi";
        await i18n.loadLanguages(lang);
        const res = await generatePdfReport("tyotodistus", json);
        setObjectURL(URL.createObjectURL(res.data));
        setShowLoading(false);
      }
    }
    fetchReport();
  }, [employmentCertificate]);

  return (
    <Modal show={employmentCertificate !== null} onHide={hide} size="xl" fullscreen="lg-down">
      <Modal.Header closeButton>{t("PdfPreview", "Pdf-esikatselu")}</Modal.Header>
      <LoadingCentered show={showLoading} />
      <iframe style={{ height: "85vh" }} src={objectURL} />
    </Modal>
  );
}
